// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.n-DropdownItem {
  color: var(--color-content-base);
  font-weight: 400;
  font-size: 14px;
  border-radius: 4px;
}
.n-DropdownItem__icon {
  color: var(--color-icon-subdued);
}
.n-DropdownItem.n-Link:hover {
  color: var(--color-content-base);
}
.n-DropdownItem:hover {
  background-color: var(--color-popover-background-hover);
  text-decoration: none;
}
.n-DropdownItem--size-md {
  height: 28px;
}
.n-DropdownItem--size-lg {
  height: 40px;
}
.n-DropdownItem--size-xl {
  height: 52px;
}
.n-DropdownItem--radius-xs {
  border-radius: 4px;
}
.n-DropdownItem--radius-sm {
  border-radius: 8px;
}
.n-DropdownItem--active,
.n-DropdownItem--active:hover {
  background-color: var(--color-neutral-background-hover);
}
.n-DropdownItem__checkmark {
  color: var(--color-accent-content-base);
}
.n-DropdownItem.n--disabled {
  opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/dropdown-item/DropdownItem.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAPA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AASF;AAPE;EACE,gCAAA;AASJ;AANE;EACE,gCAAA;AAQJ;AALE;EACE,uDAAA;EACA,qBAAA;AAOJ;AAHI;EACE,YAAA;AAKN;AAFI;EACE,YAAA;AAIN;AADI;EACE,YAAA;AAGN;AAEI;EACE,kBAAA;AAAN;AAGI;EACE,kBAAA;AADN;AAMI;;EAEE,uDAAA;AAJN;AAQE;EACE,uCAAA;AANJ;AASE;EACE,YAAA;AAPJ","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import '~venus';\n\n.n-DropdownItem {\n  color: var(--color-content-base);\n  font-weight: @fontWeight-normal;\n  font-size: @fontSize-sm;\n  border-radius: 4px;\n\n  &__icon {\n    color: var(--color-icon-subdued);\n  }\n\n  &.n-Link:hover {\n    color: var(--color-content-base);\n  }\n\n  &:hover {\n    background-color: var(--color-popover-background-hover);\n    text-decoration: none;\n  }\n\n  &--size {\n    &-md {\n      height: 28px;\n    }\n\n    &-lg {\n      height: 40px;\n    }\n\n    &-xl {\n      height: 52px;\n    }\n  }\n\n  &--radius {\n    &-xs {\n      border-radius: @layoutUnit-xs;\n    }\n\n    &-sm {\n      border-radius: @layoutUnit-sm;\n    }\n  }\n\n  &--active {\n    &,\n    &:hover {\n      background-color: var(--color-neutral-background-hover);\n    }\n  }\n\n  &__checkmark {\n    color: var(--color-accent-content-base);\n  }\n\n  &.n--disabled {\n    opacity: 0.5;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
